import { Button } from '@/components/ui/button';
import { GARMENT_TYPE_FILTERS } from '@/lib/orderItemFilters';

const OrderItemsViewToolbar = ({
  viewMode,
  onViewModeChange,
  clientCount = 0,
  testCount = 0,
  typeFilter,
  onTypeFilterChange,
  typeCounts = {},
  viewModeTestIdPrefix = 'order-items',
}) => {
  const typeButtons = GARMENT_TYPE_FILTERS.filter((option) => (
    option.key === 'all' || option.key === typeFilter || (typeCounts[option.key] || 0) > 0
  ));

  return (
    <div className="flex flex-col gap-3 p-4 border-b border-slate-200 bg-white" data-testid={`${viewModeTestIdPrefix}-view-toolbar`}>
      <div className="flex flex-wrap items-center gap-2">
        <Button
          type="button"
          size="sm"
          variant={viewMode === 'client' ? 'default' : 'outline'}
          className={viewMode === 'client' ? 'bg-blue-600 hover:bg-blue-700 text-white' : ''}
          onClick={() => onViewModeChange('client')}
          data-testid={`${viewModeTestIdPrefix}-view-client`}
        >
          Client items ({clientCount})
        </Button>
        <Button
          type="button"
          size="sm"
          variant={viewMode === 'test' ? 'default' : 'outline'}
          className={viewMode === 'test' ? 'bg-orange-600 hover:bg-orange-700 text-white border-orange-600' : 'text-orange-800 border-orange-300'}
          onClick={() => onViewModeChange('test')}
          data-testid={`${viewModeTestIdPrefix}-view-test`}
        >
          Test garments ({testCount})
        </Button>
      </div>
      <div className="flex flex-wrap items-center gap-1.5" data-testid={`${viewModeTestIdPrefix}-type-filters`}>
        {typeButtons.map((option) => {
          const count = option.key === 'all'
            ? Object.values(typeCounts).reduce((sum, value) => sum + value, 0)
            : (typeCounts[option.key] || 0);
          const isActive = typeFilter === option.key;
          return (
            <Button
              key={option.key}
              type="button"
              size="sm"
              variant={isActive ? 'default' : 'outline'}
              className={`h-7 px-2.5 text-xs ${isActive ? 'bg-slate-800 hover:bg-slate-900 text-white' : 'text-slate-700'}`}
              onClick={() => onTypeFilterChange(option.key)}
              data-testid={`${viewModeTestIdPrefix}-type-${option.key}`}
            >
              {option.label} ({count})
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default OrderItemsViewToolbar;
